import type {
    BudgetSchema,
    CreateBudgetDtoSchema,
    CreateProjectDtoSchema,
    ProjectSchema,
    UpdateBudgetDtoSchema,
    UpdateProjectDtoSchema,
} from "@nexttrack/api-schema";

import { rootApi } from "@/store/services/root-api";

export const projectsApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getProjects: builder.query<ProjectSchema[], void>({
            query: () => "projects",
            providesTags: ["Project"],
        }),
        createProject: builder.mutation<ProjectSchema, CreateProjectDtoSchema>({
            query: (body) => ({ url: "projects", method: "POST", body }),
            invalidatesTags: ["Project"],
        }),
        updateProject: builder.mutation<ProjectSchema, { id: string; data: UpdateProjectDtoSchema }>({
            query: ({ id, data }) => ({ url: `projects/${id}`, method: "PATCH", body: data }),
            invalidatesTags: ["Project", "Timeline"],
        }),
        deleteProject: builder.mutation<void, string>({
            query: (id) => ({ url: `projects/${id}`, method: "DELETE" }),
            invalidatesTags: ["Project", "Timeline"],
        }),
        addBudget: builder.mutation<BudgetSchema, { projectId: string; data: CreateBudgetDtoSchema }>({
            query: ({ projectId, data }) => ({
                url: `projects/${projectId}/budgets`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["Project", "Timeline"],
        }),
        updateBudget: builder.mutation<
            BudgetSchema,
            { projectId: string; budgetId: string; data: UpdateBudgetDtoSchema }
        >({
            query: ({ projectId, budgetId, data }) => ({
                url: `projects/${projectId}/budgets/${budgetId}`,
                method: "PATCH",
                body: data,
            }),
            invalidatesTags: ["Project", "Timeline"],
        }),
        deleteBudget: builder.mutation<void, { projectId: string; budgetId: string }>({
            query: ({ projectId, budgetId }) => ({
                url: `projects/${projectId}/budgets/${budgetId}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Project", "Timeline"],
        }),
    }),
});

export const {
    useGetProjectsQuery,
    useCreateProjectMutation,
    useUpdateProjectMutation,
    useDeleteProjectMutation,
    useAddBudgetMutation,
    useUpdateBudgetMutation,
    useDeleteBudgetMutation,
} = projectsApi;
